
import PropTypes from 'prop-types'
import PrivateRoute from './HOC/PrivateRoutes'
import PublicRoutes from './HOC/PublicRoutes'

const RouteValidator = ({ hasAuth, component: Component, ...props }) => {
  return hasAuth
    ? <PrivateRoute Component={Component} {...props} />
    : <PublicRoutes Component={Component} {...props} />
}

RouteValidator.propTypes = {
  component: PropTypes.elementType.isRequired,
  hasAuth: PropTypes.bool,
  path: PropTypes.string
}

export default RouteValidator

